import React from "react";
import { ModalWrapper } from "../../../../../../shared/components/ModalWrapper";
import CommonButtons from "src/shared/components/CommonButtons";
import { Order } from "src/shared/services/interfacev2";
import { useFormatAmount } from "../../../home/hooks/useFormatAmount";

interface Props {
  open: boolean;
  setOpenCancelDialog: (val: boolean) => void;
  Remainingpayments: number;
  cancelData: string;
  setCancelData: (val: string) => void;
  roundValue: (val: number) => number;
  Receivedbalance: () => number;
  outstangingamount: number;
  getorder: Order | undefined;
  refundAmount: () => number;
  cancelOrder: () => void;
}

const CancelOrderDialog: React.FC<Props> = ({ open, setOpenCancelDialog, Remainingpayments, cancelData, setCancelData, Receivedbalance, outstangingamount, getorder, refundAmount, cancelOrder }) => {
  const roundValue = useFormatAmount();
  const addgestAmount = refundAmount();
  if (!open) return null;
  const deductDetails = [
    { label: "Total Outstanding Balance", value: roundValue(Number(outstangingamount)) },
    { label: "Current Order (OSB)", value: getorder?.orders[0].remainingAmount },
    { label: "Order cancel amount", value: roundValue(Receivedbalance()) },
    { label: "Excess Amount", value: roundValue(addgestAmount < 0 ? Math.abs(addgestAmount) : 0) },
    { label: "New OSB", value: roundValue(addgestAmount > 0 ? Math.abs(addgestAmount) : 0) },
  ];

  const isDeductDisabled = Number(outstangingamount) <= Number(getorder?.orders[0].remainingAmount);
  // const isDeductDisabled = Number(outstangingamount) === 0 || !deductDetails || deductDetails.length === 0 || deductDetails.every((d) => !d.value || d.value === 0);
  const refundOptions = [
    { label: "Refund", value: "refund", disabled: false },
    { label: "Deduct from Outstanding", value: "deduct_from_due", disabled: isDeductDisabled },
  ];
  const receivedAmount = getorder?.orders?.reduce((total, order) => total + Number(order?.receivedAmount || 0), 0) || 0;
  const ledgerReceivedAmount = getorder?.orders?.reduce((total, order) => total + Number(order?.ledgerReceivedAmount || 0), 0) || 0;

  return (
    <ModalWrapper title="Cancel Order" onClose={() => setOpenCancelDialog(false)} showCloseButton={true} showBackButton={false} width="max-w-xl">
      <p className="text-lg text-center">
        This action will cancel the order. <br /> Click Confirm to Cancel the Order
      </p>
      <div className="p-4">
        {Remainingpayments !== 0 && (
          <div className="flex flex-col items-center justify-center h-full mb-4">
            <div className="flex flex-row items-center gap-4">
              {refundOptions.map((option) => (
                <div key={option.value} className={`flex items-center gap-2 ${option.disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}>
                  <input
                    type="radio"
                    name="refundOption"
                    value={option.value}
                    checked={cancelData === option.value}
                    onChange={() => setCancelData(option.value)}
                    className="w-6 h-6"
                    disabled={option.disabled}
                  />
                  <p>{option.label}</p>
                </div>
              ))}
            </div>

            {cancelData === "refund" && (
              <div>
                {/* <div className="text-red-600 font-semibold text-2xl"> */}
                <div className="mt-4 flex justify-center">
                  <div className="grid grid-cols-[220px_20px_140px] text-red-600 font-semibold text-2xl">
                    <span>Refund Amount</span>
                    <span className="text-center">:</span>
                    <span className="text-right">{roundValue(receivedAmount)} QAR</span>
                  </div>
                </div>

                {/* <div className="flex">
                    <span className="w-80">Ledger Received Amount</span>
                    <span className="w-6 text-center">:</span>
                    <span className="w-40 text-right">{roundValue(ledgerReceivedAmount)} QAR</span>
                  </div> */}
                {/* </div> */}

                {ledgerReceivedAmount > 0 && (
                  <div className="mt-3 border border-gray-300 bg-yellow-50 rounded-md p-3 text-sm">
                    <strong>Note:</strong> Any amount paid through the Ledger page will be applied on the outstanding balance. To refund that amount, please use the <strong>Refund</strong> option in
                    the <strong>Ledger page</strong>.
                  </div>
                )}
              </div>
            )}

            {cancelData === "deduct_from_due" && (
              <div className="mt-4 space-y-2 font-semibold w-[390px]">
                {deductDetails.map((item, index) => (
                  <div key={index} className="flex justify-between w-full">
                    <span className="w-[65%] text-left">{item.label}</span>
                    <span className="w-[5%] text-center">:</span>
                    <span className="w-[40%] text-right">{item.value} QAR</span>
                  </div>
                ))}
                <div className="flex flex-col border-2 border-grey-600 bg-red-50 rounded-md p-2 mt-2 shadow-sm max-w-md mx-auto sm:max-w-full">
                  <h2 className="text-lg font-semibold mb-2">Note:</h2>
                  <p className="text-sm leading-relaxed">
                    Customer has an <span className="font-medium">excess amount</span>.<br />
                    To return or refund it, please go to the <span className="font-medium">Ledger page</span> and use the <span className="font-semibold">Update Refund</span> option.
                  </p>
                </div>
              </div>
            )}
          </div>
        )}
        <div className="flex justify-end gap-4 mt-6">
          <CommonButtons className="w-36" label="Cancel" variant="outlineDanger" onClick={() => setOpenCancelDialog(false)} />
          <CommonButtons
            className="w-36"
            label="Confirm"
            onClick={() => {
              cancelOrder();
              setOpenCancelDialog(false);
            }}
          />
        </div>
      </div>
    </ModalWrapper>
  );
};

export default CancelOrderDialog;
